import ContinueButton from 'js/components/core/SteppedPage/ContinueButton';
import { inject, observer } from 'mobx-react';
import React from 'react';
import StepPage from './StepPage';

@inject('page')
@observer
export default class SizeDetails extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      step1: 1,
      step2: 0,
      step3: 0,
      catalog: [],
      requestInProgress: 0,
      errorMessage: null,
    };
  }

  sizeOptions = [
    {
      value: 'small',
      label: 'Small',
      tip: 'Between 0 - 1kg',
      image: 'size-small.png',
    },
    {
      value: 'medium',
      label: 'Medium',
      tip: 'More than 1kg less than or equal to 2kg',
      image: 'size-medium.png',
    },
    {
      value: 'large',
      label: 'Large',
      tip: 'More than 2kg less than or equal to 3kg',
      image: 'size-large.png',
    },
    {
      value: 'extra-large',
      label: 'Extra Large',
      tip: 'Long and bulky items more than 3 kg',
      image: 'size-very-large.png',
    }
  ];

  backNav = () =>
    AppUser.isLoggedIn
      ? AppState.previousPage === 'UserDashboardPage'
        ? {
          mode: 'back',
          text: 'Dashboard',
          url: url('user-dashboard-page'),
        }
        : {
          mode: 'back',
          text: 'My items',
          url: url('my-items-page'),
        }
      : { mode: 'normal' };

  render() {
    const page = this.props.page;

    return (
      <StepPage current={1} page={page} backTo={'/create-link/item'}>
        <h5>Select the size that best explain the item package</h5>

        {this.sizeOptions.map(option => {
          let checked = page.size === option.value

          return (
            <button
              className='tw-flex tw-w-full tw-justify-center tw-items-center tw-p-2 hover:tw-bg-gray-100 tw-rounded-md mb-2'
              key={option.value}
              style={{
                background: checked ? '#f3f4f6' : 'transparent',
                border: checked ? '1.5px solid #080445' : '1px solid #f3f4f6',
              }}
              onClick={() => page.setSize(option.value)}
            >
              <div className='tw-flex-1 tw-flex tw-gap-4 tw-items-center'>
                <img src={`/images/size/${option.image}`} width={70} height={70} />

                <div className='tw-text-left'>
                  <h4 className='tw-mb-0 tw-font-medium tw-text-lg'>{option.label}</h4>
                  <p className='tw-font-normal'>{option.tip}</p>
                </div>
              </div>

                <svg width="25" height="36" viewBox="0 0 25 36" fill="none" xmlns="http://www.w3.org/2000/svg" className='tw-h-8 tw-w-8'>
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12.0436 7C5.94451 7 1 11.925 1 18C1 24.075 5.94451 29 12.0436 29C18.1426 29 23.0871 24.075 23.0871 18C23.0871 11.925 18.1426 7 12.0436 7ZM16.8304 16.14C16.9186 16.0396 16.9857 15.9227 17.0278 15.7962C17.0699 15.6696 17.0862 15.5359 17.0757 15.403C17.0652 15.2701 17.0281 15.1406 16.9666 15.0221C16.9051 14.9037 16.8204 14.7987 16.7176 14.7133C16.6147 14.628 16.4958 14.564 16.3677 14.5251C16.2397 14.4862 16.1051 14.4732 15.9719 14.4868C15.8388 14.5005 15.7097 14.5405 15.5923 14.6046C15.4749 14.6687 15.3716 14.7555 15.2884 14.86L10.9713 20.019L8.73752 17.793C8.54817 17.6108 8.29457 17.51 8.03134 17.5123C7.7681 17.5146 7.51629 17.6198 7.33015 17.8052C7.14401 17.9906 7.03842 18.2414 7.03614 18.5036C7.03385 18.7658 7.13504 19.0184 7.31792 19.207L10.3298 22.207C10.4285 22.3052 10.5466 22.3818 10.6766 22.4321C10.8066 22.4823 10.9457 22.505 11.0851 22.4986C11.2244 22.4923 11.3608 22.4572 11.4858 22.3954C11.6107 22.3337 11.7213 22.2467 11.8106 22.14L16.8304 16.14Z"
                    fill={checked ? '#080445' : '#f3f4f6'}
                  />
                </svg>
            </button>
          )
        })}

        <ContinueButton onClick={page.nextStep} disabled={!page.size}>Continue</ContinueButton>
      </StepPage>
    );
  }
}
